import type { PropsWithChildren } from "react"

import { AppContent } from "@/components/app-content"
import { AppShell } from "@/components/app-shell"
import { PartnerMobileHeader } from "@/components/partner-mobile-header"
import { PartnerSidebar } from "@/components/partner-sidebar"

export default function PartnerSidebarLayout({ children }: PropsWithChildren) {
  return (
    <AppShell variant="sidebar">
      <PartnerSidebar />
      {/* --app-header-h is what the mobile bar takes off the viewport; it's 0
          on desktop, where the bar is hidden. Full-height panes inside the
          shell subtract it via .h-app-viewport. */}
      <AppContent
        variant="sidebar"
        className="[--app-header-h:3.5rem] md:[--app-header-h:0px]"
      >
        <PartnerMobileHeader />
        <div className="flex min-h-full w-full max-w-6xl flex-col self-center p-4 sm:p-6 lg:p-10">
          {children}
        </div>
      </AppContent>
    </AppShell>
  )
}
